import {
    TooLargeForLocalAttachmentMultiple,
    TooLargeForLocalAttachmentSingle,
} from './ifIsOverSizeLimitShowErrorMessage.locstring.json';
import loc, { format } from 'owa-localize';
import type { AttachmentFileList } from 'owa-attachment-file-types';

import { trace } from 'owa-trace';
import { OneMBInBytes } from '../attachmentConstants';
import getAvailableLocalAttachmentSize from '../getAvailableLocalAttachmentSize';
import type { AttachmentInfoBarMessageId } from './AttachmentInfoBarMessageId';
import type { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import type AttachmentWellViewState from '../../schema/AttachmentWellViewState';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';

export default function ifIsOverSizeLimitShowErrorMessage(
    files: AttachmentFileList,
    attachmentWellViewState: AttachmentWellViewState,
    infoBar?: InfoBarHostViewState
): boolean {
    let newAttachmentsSize: number = 0;
    for (let i = 0, file; (file = files[i]); i++) {
        newAttachmentsSize += file.size;
    }

    const availableLocalAttachmentSize = getAvailableLocalAttachmentSize(attachmentWellViewState);

    if (newAttachmentsSize > availableLocalAttachmentSize) {
        const sizeInMB = Math.floor(availableLocalAttachmentSize / OneMBInBytes);
        let message: string;
        let infoMessageId: AttachmentInfoBarMessageId;
        if (files.length > 1) {
            infoMessageId = 'ErrorTooLargeForLocalAttachmentMultiple';
            message = format(loc(TooLargeForLocalAttachmentMultiple), sizeInMB);
        } else {
            infoMessageId = 'ErrorTooLargeForLocalAttachmentSingle';
            message = format(loc(TooLargeForLocalAttachmentSingle), sizeInMB);
        }

        addInfoBarMessage(infoBar, infoMessageId, [message]);
        return true;
    } else {
        trace.info(
            'Attachment: TotalSize = ' +
                Math.floor(attachmentWellViewState.totalClassicAttachmentSize / (1024 * 1024))
        );
        return false;
    }
}
